import { Component } from '@angular/core';
import { membersuiteCreditMemoEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Credit Memos') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitecreditmemo-form',
    templateUrl: './membersuitecreditmemo.form.component.html'
})
export class membersuiteCreditMemoFormComponent extends BaseFormComponent {
    public record!: membersuiteCreditMemoEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

